/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Raffled_DismissInputs */



/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Promos_Raffled_DismissInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_raffled_dismiss = /** @type {((inputs?: Promos_Raffled_DismissInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Raffled_DismissInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fechar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi")
	return /** @type {LocalizedString} */ ("Dismiss")
});